import {TypeEntityLinkTo, TypeNav, TypeNavKey } from 'Type'

const HookNavContext = <T extends TypeEntityLinkTo>(key :TypeNavKey, nav? :TypeNav<any>) :T | undefined => {
    if (nav?.error) return undefined
    const entity :T | undefined = nav?.context[key] as T
    if (nav && !entity) throw new Error('Context entity not found')
    return entity
}

export default HookNavContext